import LOOKUP_TYPES, {
  SUCCESS_PLAN_ACTIONS,
  SUCCESS_PLAN_TABS,
} from '../../common/constants/SuccessPlanConstants';
import responseFormatter from '../../common/util/ResponseFormatter';
import {
  fetchSuccessPlanByIdV2,
  createSuccessPlanV2,
  editSuccessPlanV2,
  successPlanDrawerState,
  fetchSuccessPlanStatusV2,
  fetchSuccessPlanProgressLookupsV2,
  fetchSuccessPlanStatusLookupsV2,
  cancelSuccessPlanCompleteV2,
  completeSuccessPlanV2,
  markSuccessPlanInprogressV2,
  duplicateSuccessPlanV2,
  archiveSuccessPlanV2,
  changeSuccessPlanTabV2,
  resetSuccessPlansV2,
} from '../routines/successPlanRoutines';

const { SUCCESS_PLAN_STATUS, SUCCESS_PLAN_PROGRESS } = LOOKUP_TYPES;
const initialSuccessPlanState = {
  data: null,
  loading: false,
  validationData: {},
  error: null,
};

const initialState = {
  actionLoading: false,
  [SUCCESS_PLAN_STATUS]: {
    data: [],
    dataMap: {},
    loading: false,
    error: null,
  },
  [SUCCESS_PLAN_PROGRESS]: {
    data: [],
    dataMap: {},
    loading: false,
    error: null,
  },
  drawer: {
    action: null,
    visibility: false,
  },
  entityId: null,
  level: null,
  successPlan: initialSuccessPlanState,
  successPlanStatus: {
    data: null,
    loading: false,
    error: null,
    showModal: false,
    action: null,
  },
  duplicateSuccessPlan: {
    data: null,
    loading: false,
    error: null,
  },
  successPlanTab: SUCCESS_PLAN_TABS.MILESTONE,
};

const successPlanReducerV2 = (state = initialState, action) => {
  const payload = action?.payload;
  switch (action.type) {
    case fetchSuccessPlanByIdV2.TRIGGER:
      return {
        ...state,
        successPlan: { ...state.successPlan, data: null, loading: true },
        // if the success plan id is the same as the one in the state, it's a refresh no need to change the tab
        successPlanTab:
          payload?.successPlanId === state?.successPlan?.data?.successPlanId
            ? state.successPlanTab || SUCCESS_PLAN_TABS.MILESTONE
            : SUCCESS_PLAN_TABS.MILESTONE,
      };
    case fetchSuccessPlanByIdV2.SUCCESS:
      return {
        ...state,
        successPlan: {
          ...state.successPlan,
          loading: false,
          data: payload,
        },
      };
    case fetchSuccessPlanByIdV2.FAILURE:
      return {
        ...state,
        successPlan: {
          ...state.successPlan,
          loading: false,
          error: payload.error,
        },
      };
    case editSuccessPlanV2.TRIGGER:
    case createSuccessPlanV2.TRIGGER:
      return {
        ...state,
        actionLoading: true,
      };
    case createSuccessPlanV2.SUCCESS:
    case createSuccessPlanV2.FAILURE:
    case editSuccessPlanV2.SUCCESS:
    case editSuccessPlanV2.FAILURE:
      return {
        ...state,
        actionLoading: false,
      };
    case successPlanDrawerState.TRIGGER:
      return {
        ...state,
        drawer: {
          ...state.drawer,
          action: payload.action,
          visibility: payload.visibility,
          successPlanId: payload.successPlanId,
        },
      };
    case fetchSuccessPlanStatusV2.TRIGGER: {
      return {
        ...state,
        successPlanStatus: {
          ...state.successPlanStatus,
          data: null,
          loading: true,
          error: null,
          showModal: true,
          action: action.payload.action,
        },
      };
    }
    case fetchSuccessPlanStatusV2.SUCCESS: {
      return {
        ...state,
        successPlanStatus: {
          ...state.successPlanStatus,
          data: action.payload,
          loading: false,
        },
      };
    }
    case fetchSuccessPlanStatusV2.FAILURE: {
      return {
        ...state,
        successPlanStatus: {
          ...state.successPlanStatus,
          data: null,
          loading: false,
          error: action.payload.error,
          showModal: false,
        },
      };
    }
    case completeSuccessPlanV2.TRIGGER:
      return {
        ...state,
        actionLoading: true,
        successPlanStatus: {
          ...state.successPlanStatus,
          data: null,
          loading: true,
          error: null,
          showModal: true,
          action: SUCCESS_PLAN_ACTIONS.COMPLETE,
        },
      };
    case completeSuccessPlanV2.SUCCESS:
    case markSuccessPlanInprogressV2.SUCCESS: {
      return {
        ...state,
        actionLoading: false,
        successPlanStatus: {
          ...state.successPlanStatus,
          data: null,
          loading: false,
          error: null,
          showModal: false,
          action: null,
          successPlanId: null,
        },
      };
    }
    case cancelSuccessPlanCompleteV2.TRIGGER: {
      return {
        ...state,
        successPlanStatus: {
          ...state.successPlanStatus,
          data: null,
          loading: false,
          error: null,
          action: null,
          showModal: false,
          successPlanId: null,
        },
      };
    }
    case duplicateSuccessPlanV2.TRIGGER:
      return {
        ...state,
        actionLoading: true,
        successPlanStatus: {
          ...state.successPlanStatus,
          data: null,
          loading: true,
          error: null,
          showModal: true,
          action: SUCCESS_PLAN_ACTIONS.DUPLICATE_MOVE,
          duplicateOnly: action.payload.duplicateOnly,
        },
      };
    case duplicateSuccessPlanV2.SUCCESS:
      return {
        ...state,
        actionLoading: false,
        successPlanStatus: {
          ...state.successPlanStatus,
          data: null,
          loading: false,
          error: null,
          showModal: false,
          duplicateOnly: false,
        },
      };
    case duplicateSuccessPlanV2.FAILURE:
      return {
        ...state,
        actionLoading: false,
        successPlanStatus: {
          ...state.successPlanStatus,
          loading: false,
          error: null,
          showModal: false,
          duplicateOnly: false,
        },
      };
    case archiveSuccessPlanV2.TRIGGER: {
      return {
        ...state,
        actionLoading: true,
        successPlanStatus: {
          ...state.successPlanStatus,
          loading: true,
          error: null,
          showModal: true,
          action: SUCCESS_PLAN_ACTIONS.ARCHIVE,
        },
      };
    }
    case archiveSuccessPlanV2.SUCCESS: {
      return {
        ...state,
        actionLoading: false,
        successPlanStatus: {
          loading: false,
          error: null,
          showModal: false,
          action: null,
        },
      };
    }
    case archiveSuccessPlanV2.FAILURE:
      return {
        ...state,
        actionLoading: false,
        successPlanStatus: {
          ...state.successPlanStatus,
          loading: false,
          error: null,
          showModal: false,
          action: null,
        },
      };

    // LOOKUP STUFF BELOW
    case fetchSuccessPlanStatusLookupsV2.TRIGGER: {
      return {
        ...state,
        [SUCCESS_PLAN_STATUS]: { ...state[SUCCESS_PLAN_STATUS], loading: true },
      };
    }
    case fetchSuccessPlanStatusLookupsV2.FAILURE: {
      return {
        ...state,
        [SUCCESS_PLAN_STATUS]: {
          ...state[SUCCESS_PLAN_STATUS],
          error: action.payload.error,
          loading: false,
        },
      };
    }
    case fetchSuccessPlanStatusLookupsV2.SUCCESS: {
      return {
        ...state,
        [SUCCESS_PLAN_STATUS]: {
          ...state[SUCCESS_PLAN_STATUS],
          data: action.payload,
          dataMap: responseFormatter(action.payload, 'lookupId'),
          loading: false,
          error: null,
        },
      };
    }
    case fetchSuccessPlanProgressLookupsV2.TRIGGER: {
      return {
        ...state,
        [SUCCESS_PLAN_PROGRESS]: {
          ...state[SUCCESS_PLAN_PROGRESS],
          loading: true,
        },
      };
    }
    case fetchSuccessPlanProgressLookupsV2.FAILURE: {
      return {
        ...state,
        [SUCCESS_PLAN_PROGRESS]: {
          ...state[SUCCESS_PLAN_PROGRESS],
          error: action.payload.error,
          loading: false,
        },
      };
    }
    case fetchSuccessPlanProgressLookupsV2.SUCCESS: {
      return {
        ...state,
        [SUCCESS_PLAN_PROGRESS]: {
          ...state[SUCCESS_PLAN_PROGRESS],
          data: action.payload,
          dataMap: responseFormatter(action.payload, 'lookupId'),
          loading: false,
          error: null,
        },
      };
    }
    case changeSuccessPlanTabV2.TRIGGER: {
      return {
        ...state,
        successPlanTab: action.payload,
      };
    }
    case resetSuccessPlansV2.TRIGGER: {
      return {
        ...state,
        successPlan: initialSuccessPlanState,
      };
    }
    default:
      return state;
  }
};

export default successPlanReducerV2;
